import { render, staticRenderFns } from "./ReporteEstadistica.vue?vue&type=template&id=5cc01210&"
import script from "./ReporteEstadistica.vue?vue&type=script&lang=js&"
export * from "./ReporteEstadistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports